let body = document.getElementsByTagName('body');
let header = document.getElementsByTagName('header');
//Navigation Menu
let navToggle = document.getElementById('nav-toggle');
let headerNav = document.getElementsByClassName('header__nav');
let headerNavToggles = headerNav[0].getElementsByClassName('menu-toggle');
let subMenu = header[0].getElementsByClassName('sub-menu');

let languageMobile = header[0].getElementsByClassName('header__languages');

// window.addEventListener('resize', windowSize);
// window.addEventListener('load', windowSize);

navToggle.addEventListener('click', function() {
    if (window.innerWidth < 992) {
        console.log('it is under 992px');
        if (header[0].classList.contains('nav-open')) {
            console.log('header contains nav-open');
            header[0].classList.remove('nav-open');
        } else {
            header[0].classList.add('nav-open');
            console.log('header does not contain nav-open');
        }

        if (languageMobile[0].classList.contains('open')) {
            console.log('language has open');
            languageMobile[0].classList.remove('open');
        }
    }
})

for (let i = 0; i < headerNavToggles.length; i++) {
        
    headerNavToggles[i].addEventListener('click', function() {
        if (window.innerWidth < 992) {
            if (headerNavToggles[i].classList.contains('open')) {
                subMenu[i].style.maxHeight = '0';
                headerNavToggles[i].classList.remove('open');
            } else {
                console.log(subMenu);
                subMenu[i].style.maxHeight = subMenu[i].scrollHeight + 'px';
                headerNavToggles[i].classList.add('open');
            }
        }
    })
}

// function windowSize() {
// }

languageMobile[0].addEventListener('click', function() {
    if (languageMobile[0].classList.contains('open')) {
        languageMobile[0].classList.remove('open');
    } else {
        languageMobile[0].classList.add('open');
    }
})